import React, { useState } from 'react'

const ConfirmationDialog = ({ isOpen, message, onConfirm, onCancel }) => {
    const [overtimeReason, setOvertimeReason] = useState('')

    if (!isOpen) return null

    const handleConfirm = () => {
        onConfirm(overtimeReason) // Pass the reason back to the parent
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
            <div className="card-surface w-full max-w-sm p-6">
                <p className="text-lg mb-4">{message}</p>

                <label className="form-label">Reason for Overtime</label>
                <input
                    type="text"
                    value={overtimeReason}
                    onChange={(e) => setOvertimeReason(e.target.value)}
                    placeholder="Enter reason"
                    className="input-field"
                />

                <div className="flex justify-end gap-3 mt-4">
                    <button onClick={onCancel} className="btn-secondary">
                        No
                    </button>
                    <button
                        onClick={handleConfirm}
                        className="btn-primary"
                        disabled={!overtimeReason} // Disable if no reason is provided
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationDialog
